import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";

import { Button, Form, Select, DatePicker, Radio, Input } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

import { getFitCategory } from '../../redux/actions/fitCategory.action';
import { getOrderStatus } from '../../redux/actions/orderStatus.action';
import { getAllSaleperson } from '../../redux/actions/salesPerson';
import { getReportIP } from '../../redux/actions/reportIP.action';
import { getWashType } from '../../redux/actions/washType.action';
import { loadCustomers } from '../../redux/actions/customerForm';
import { getWashName } from "../../redux/actions/wash.action";
import { getFabric } from '../../redux/actions/fabric.action';
import { getSeason } from '../../redux/actions/season.action';
import { getRegion } from '../../redux/actions/region.action';
import { getGender } from '../../redux/actions/gender.action';
import { getStyle } from '../../redux/actions/style';

import { getCut } from '../../redux/actions/cut.action';
import { Row as Brow, Col as Bcol } from "reactstrap";
import { ReadCookie } from "../../utils/readCookie";
import { useHistory } from "react-router-dom";
import "../ProducList/productList.css";
import moment from 'moment';

const { RangePicker } = DatePicker;

const PendingPOD = ({ token }) => {
    const { wash, fabric, salePerson, washType, customerForms, gender, style, cut, region } = useSelector(state => state)
    const [washID, setWashID] = useState('All')
    const focusInput = useRef(null);
    const [washTypeID, setWashTypeID] = useState('All')
    const [date, setDate] = useState([moment().startOf('year').format("MM/DD/YYYY"), moment().format("MM/DD/YYYY")])
    const [fabricID, setFabricID] = useState('All')
    const [genderID, setGenderID] = useState('All')
    const [fitCatID, setFitCatID] = useState('All')
    const [customer, setCustomer] = useState('All')
    const [styleID, setStyle] = useState("All")
    const [regionID, setRegionID] = useState("All")
    const [selectedParameters, setSelectedParameters] = useState({
        spName: "",
        region: "",
        cut: "",
        style: "",
        washType: "",
        washName: "",
        fabric: "",
        gender: "",
        customer: ""

    })
    const [sku, setSKU] = useState("")
    const [salePersonName, setSalePersonName] = useState("All")
    const menuId = ReadCookie('menuId')
    const userName = ReadCookie('name')
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [showGroup, setShowGroup] = useState(false)
    const [groupBY, setGroupBy] = useState(1)
    const [reportIP, setReportIP] = useState('');
    const [groupName, setGroupName] = useState('Sales Person');
    const { Option } = Select;
    let history = useHistory();

    useEffect(() => {
        dispatch(getReportIP(token)).then((res) => { setReportIP(res.payload.data[0].report_server_ip) });
        dispatch(getOrderStatus(token, menuId));
        dispatch(getAllSaleperson(token, menuId));
        dispatch(getFabric(token, menuId));
        dispatch(getFitCategory(token, menuId));
        dispatch(getSeason(token, menuId));
        dispatch(getWashName(token, menuId));
        dispatch(getWashType(token, menuId));
        dispatch(getGender(token, menuId));
        dispatch(getStyle(token, menuId));
        dispatch(getCut(token, menuId));
        dispatch(getRegion(token, menuId));
    }, [])

    const getReportName = () => {
        if (showGroup && groupBY === 9) {
            return "rptPODreportGroupByRegion.rptdesign"
        }
        else if (showGroup) {
            return "rpt_POD_sale_order_group_report.rptdesign"
        }
        else
            return "rptPODReport.rptdesign"
    }

    const handleChanges = (val) => {
        if (val === "" || val === 'All') return
        setCustomer(val);
        dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null)).then(
            (res) => {
                if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
                    setCustomer(res?.payload?.data)
                }
            }
        );
    };

    const onRegionChange = (e, f) => {
        setRegionID(e)

        setSelectedParameters({ ...selectedParameters, region: f.children });
    }

    const onSalePersonChange = (e, f) => {
        setSalePersonName(e)
        setSelectedParameters({ ...selectedParameters, spName: f.children });
    }

    const onFitChange = (e, f) => {
        setFitCatID(e)
        setSelectedParameters({ ...selectedParameters, cut: f.children });
    }
    const onStyleChange = (e, f) => {
        setStyle(e)
        setSelectedParameters({ ...selectedParameters, style: f.children });
    }
    const onWashNameChange = (e, f) => {
        setWashID(e)
        setSelectedParameters({ ...selectedParameters, washName: f.children });
    }
    const onWashTypeChange = (e, f) => {
        setWashTypeID(e)
        setSelectedParameters({ ...selectedParameters, washType: f.children });
    }
    const onFabricChange = (e, f) => {
        setFabricID(e)
        setSelectedParameters({ ...selectedParameters, fabric: f.children });
    }
    const onGenderChange = (e, f) => {
        setGenderID(e)
        setSelectedParameters({ ...selectedParameters, gender: f.children });
    }
    const onCustomerChange = (e, f) => {
        setCustomer(e)

        setSelectedParameters({ ...selectedParameters, customer: f.children[1] });
    }

    useEffect(() => {
        if (groupBY === 1) {
            return setGroupName("Sales Person")
        }
        else if (groupBY === 2) {
            return setGroupName("Wash Code")
        }
        else if (groupBY === 3) {
            return setGroupName("Customer")
        }
        else if (groupBY === 4) {
            return setGroupName("Base Sku")
        }
        else if (groupBY === 5) {
            return setGroupName("Style")
        }
        else if (groupBY === 6) {
            return setGroupName("Gender")
        }
        else if (groupBY === 7) {
            return setGroupName("Fabric")
        }
        else if (groupBY === 8) {
            return setGroupName("FIT")
        }
        else if (groupBY === 9) {
            return setGroupName("Region")
        }
    }, [groupName, groupBY])

    const onFinish = () => {
        window.open(`${reportIP}birt/frameset?__report=${getReportName()}&__format=html&__svg=true&__locale=en_US&__timezone=PLT&__masterpage=true&__rtl=false&__cubememsize=10&__resourceFolder=C%3A%5CUsers%5Cadm%5Ceclipse%5Crcp-2021-09%5Ceclipse%5Cworkspace%5CERP-Reports&__parameterpage=false&-632080003&${`p_from_date=${date[0]}`}&${`p_to_date=${date[1]}`}&${customer === 'All' ? "__isnull=p_customer_id" : `p_customer_id=${customer}`}&${salePersonName === 'All' ? "__isnull=p_salesperson_id" : `p_salesperson_id=${salePersonName}`}&${washID === 'All' ? "__isnull=p_wash_name_id" : `p_wash_name_id=${washID}`}&${styleID === 'All' ? "__isnull=p_style_id" : `p_style_id=${styleID}`}&${sku === "" ? "__isnull=p_sku" : `p_sku=${sku}`}&${washTypeID === 'All' ? "__isnull=p_wash_type_id" : `p_wash_type_id=${washTypeID}`}&${fitCatID === 'All' ? "__isnull=p_fit_id" : `p_fit_id=${fitCatID}`}&${fabricID === 'All' ? "__isnull=p_fabric_id" : `p_fabric_id=${fabricID}`}&${genderID === 'All' ? "__isnull=p_season_id" : `p_season_id=${genderID}`}&${regionID === 'All' ? "__isnull=p_region_id" : `p_region_id=${regionID}`}&${showGroup && `p_group_id=${groupBY}`}&${showGroup && `p_group_name=${groupName}`}&user_name=${userName}&selectedParameters=${`Selected Filters : Start Date : ${date[0]}, End Date : ${date[1]}, Customer : ${selectedParameters.customer ? selectedParameters.customer : "All"}, Sales Person : ${selectedParameters.spName ? selectedParameters.spName : "All"},Region: ${selectedParameters.region ? selectedParameters.region : "All"}, Fit/Cut : ${selectedParameters.cut ? selectedParameters.cut : "All"}, Style : ${selectedParameters.style ? selectedParameters.style : "All"}, Wash Name : ${selectedParameters.washName ? selectedParameters.washName : "All"}, Wash Type : ${selectedParameters.washType ? selectedParameters.washType : "All"}, Fabric : ${selectedParameters.fabric ? selectedParameters.fabric : "All"},Gender : ${selectedParameters.gender ? selectedParameters.gender : "All"}, SKU : ${sku ? sku : "All"},`}`)
    };

    function debounce(cb, delay = 1000) {
        let timeout
        return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay)
        }
    }

    const clearFields = (event, type) => {
        event.preventDefault()

        if (type === 'customer') {
            setCustomer('All')
            setSelectedParameters({ ...selectedParameters, customer: "" })

        }
        else if (type === 'fabric') {
            setFabricID('All')
            setSelectedParameters({ ...selectedParameters, fabric: "" })

        }
        else if (type === 'washName') {
            setWashID('All')
            setSelectedParameters({ ...selectedParameters, washName: "" })

        }
        else if (type === 'style') {
            setStyle('All')
            setSelectedParameters({ ...selectedParameters, style: "" })
        }
        else if (type === 'sku') {
            setSKU('')
        }
        else if (type === 'region') {
            setRegionID('All')
            setSelectedParameters({ ...selectedParameters, region: "" })

        }
        else if (type === 'washType') {
            setWashTypeID('All')
            setSelectedParameters({ ...selectedParameters, washType: "" })

        }
        else if (type === 'salesPerson') {
            setSalePersonName('All')
            setSelectedParameters({ ...selectedParameters, spName: "" })
        }
        else if (type === 'fit') {
            setFitCatID('All')
            setSelectedParameters({ ...selectedParameters, cut: "" })

        }
        else if (type === 'gender') {
            setGenderID('All')
            setSelectedParameters({ ...selectedParameters, gender: "" })
        }
    };

    const optimizedFn = useCallback(debounce(handleChanges), []);



    return (
        <div className='product-detail-main-wrapper'
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            <div className='product-detail-main' style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
                <div className='pageHead ' >
                    <h4 className='prod-det-title-hd mb-0'>Booked Orders Summary</h4>
                    <div>
                        <Button className="pos-right-10 iconBtn crudBTN" shape='circle' icon={<CloseCircleOutlined className='color-red' />} onClick={() => history.push("/")} />
                    </div>
                </div>
                <div className='product-detail-content'>
                    <Form
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        layout="horizontal"
                        form={form} name="control-hooks" onFinish={onFinish}>
                        <Brow>
                            <Bcol lg={8} xl={8} xxl={8}>
                                <div className="date-filter">
                                    <h3 className="filter-title">Date Range</h3>
                                    <Form.Item
                                        name="date"
                                        label="Date"
                                    >
                                        <RangePicker
                                            defaultValue={[moment(date[0]), moment(date[1])]}
                                            format="MM/DD/YYYY" onChange={(dates) => {

                                                let sDate = moment(dates[0]._d).format('MM/DD/YYYY');
                                                let eDate = moment(dates[1]._d).format('MM/DD/YYYY');
                                                setDate([sDate, eDate])
                                            }} />
                                    </Form.Item>
                                </div>

                                <div className="date-filter">
                                    <h3 className="filter-title">Filters</h3>
                                    <Form.Item
                                        name="customer"
                                        label="Customer"
                                    >
                                        <Select

                                            showSearch
                                            optionFilterProp="children"
                                            className="filter-fields"
                                            onSelect={(e, f) => onCustomerChange(e, f)}
                                            loading={customerForms.loading}
                                            // placeholder="Select Customers"
                                            onSearch={(value) => {
                                                optimizedFn(value)
                                            }}
                                            ref={focusInput}
                                            defaultValue="All"
                                            value={customer}
                                        >
                                            {customerForms?.payload?.data.map(
                                                (item) => {
                                                    return (
                                                        <Option
                                                            key={item.customer_id}
                                                            value={item.customer_id}
                                                        >
                                                            {" "}
                                                            {`${item.customer_code} ${item.customer_name}`}
                                                        </Option>
                                                    );
                                                }
                                            )}
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "customer")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="sp"
                                        label="Sale Person"
                                    >
                                        <Select
                                            showSearch
                                            defaultValue={form.getFieldValue().sp}

                                            optionFilterProp="children"
                                            onChange={(e, f) => onSalePersonChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Sale Person"
                                            loading={salePerson?.loading}
                                            // defaultValue="All"
                                            value={salePersonName}
                                        >
                                            {
                                                salePerson?.payload?.data.map((item) => {
                                                    return <Option defaultValue="All" key={item.sales_person_id} value={item.sales_person_id} title={item.salesperson_name}>{item.salesperson_name}</Option>
                                                })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "salesPerson")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="washType"
                                        label="Wash Type"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(e, f) => onWashTypeChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Wash Type"
                                            loading={washType?.loading}
                                            defaultValue="All"
                                            value={washTypeID}
                                        >
                                            {
                                                washType?.payload?.data.map((item) => {
                                                    return <Option defaultValue="All" key={item.wash_type_id} value={item.wash_type_id}>{item.wash_type_name}</Option>
                                                })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "washType")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="washName"
                                        label="Wash Name"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(e, f) => onWashNameChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Wash Name"
                                            loading={wash?.loading}
                                            defaultValue="All"
                                            value={washID}
                                        >
                                            {
                                                wash?.payload?.data.map((item) => {
                                                    return <Option defaultValue="All" key={item.wash_id} value={item.wash_id}>{item.wash_name}</Option>
                                                })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "washName")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="fit"
                                        label="Fit/Cut"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(e, f) => onFitChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Fit Category"
                                            loading={cut?.loading}
                                            defaultValue="All"
                                            value={fitCatID}
                                        >
                                            {
                                                cut?.payload?.data.map((item) => {
                                                    return <Option defaultValue="All" key={item.cut_id} value={item.cut_id}>{item.cut_name}</Option>
                                                })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "fit")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="fabric"
                                        label="Fabric"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(e, f) => onFabricChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Fabric"
                                            loading={fabric?.loading}
                                            defaultValue="All"
                                            value={fabricID}
                                        >
                                            {
                                                fabric?.payload?.data.map((item) => {
                                                    return <Option defaultValue="All" key={item.fabric_id} value={item.fabric_id}>{item.fabric_name}</Option>
                                                })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "fabric")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="gender"
                                        label="Gender"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(e, f) => onGenderChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Gender"
                                            loading={gender?.loading}
                                            defaultValue="All"
                                            value={genderID}
                                        >
                                            {
                                                gender?.payload?.data.map((item) => {
                                                    return <Option defaultValue="All" key={item.gender_id} value={item.gender_id}>{item.gender_name}</Option>
                                                })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "gender")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="region"
                                        label="Region"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            defaultValue="All"
                                            onChange={(e, f) => onRegionChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Region"
                                            loading={region?.loading}
                                            value={regionID}
                                        >
                                            {region?.payload?.data.map((item) => {
                                                return <Option defaultValue={"All"} key={item.region_id} value={item.region_id} >{item.region_name}</Option>
                                            })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "region")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="style"
                                        label="Style"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            defaultValue="All"
                                            onChange={(e, f) => onStyleChange(e, f)}
                                            className="filter-fields"
                                            // placeholder="Select Style"
                                            loading={style?.loading}
                                            value={styleID}
                                        >
                                            {style?.payload?.data.map((item) => {
                                                return <Option defaultValue={"All"} key={item.style_id} value={item.style_id}>{item.style_name}</Option>
                                            })
                                            }
                                        </Select>
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "style")}>CLEAR</button>
                                    </Form.Item>
                                    <Form.Item
                                        name="sku"
                                        label="SKU"
                                    >
                                        <Input
                                            // placeholder="Enter SKU"
                                            className="filter-fields"
                                            onChange={(e) => setSKU(e.target.value)}
                                            value={sku}
                                        />
                                        <button className="auto-complete-text-btn" onClick={(e) => clearFields(e, "sku")}>CLEAR</button>
                                    </Form.Item>

                                </div>
                            </Bcol>
                            <Bcol lg={4} xl={4} xxl={4}>
                                <div className="date-filter">
                                    <h3 className="filter-title">Group</h3>
                                    <Form.Item
                                        name="group">
                                        <Radio.Group onChange={(e) => setShowGroup(e.target.value)} defaultValue={showGroup} style={{ width: 500 }}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>
                                {showGroup && <div className="date-filter">
                                    <h3 className="filter-title">Group By</h3>
                                    <Form.Item name="productStatus">
                                        <Radio.Group onChange={(e) => setGroupBy(e.target.value)} defaultValue={groupBY} >
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <Radio value={1}>Sale Person</Radio>
                                                <Radio value={2}>Wash Code</Radio>
                                                <Radio value={3}>Customer</Radio>
                                                <Radio value={4}>Base SKU</Radio>
                                                <Radio value={5}>Style</Radio>
                                                <Radio value={6}>Gender</Radio>
                                                <Radio value={7}>Fabric</Radio>
                                                <Radio value={8}>Fit/Cut</Radio>
                                                <Radio value={9}>Region</Radio>
                                            </div>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>}

                                <div>
                                    <Form.Item >
                                        <Button type="primary" htmlType="submit" className='w-100'>
                                            Search
                                        </Button>
                                    </Form.Item>
                                </div>
                            </Bcol>
                        </Brow>
                    </Form>
                </div>
            </div>
        </div >
    );
};

export default PendingPOD;
